import autoTable from 'jspdf-autotable';
import {
  addText,
  createPdfDocument,
  paragraphSize,
  setFont,
  titleSize,
} from '../pdf';
import { tzNormalizeDate } from '../date';
import { DATE_FORMAT, TIME_FORMAT } from '../../config/locale';

const fmtMoney = (n) =>
  Number(n || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const printBillingSummary = ({ rows = [], electronicTotal }) => {
  const doc = createPdfDocument('l', 'mm', 'a4');
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 10;

  setFont(doc, 'bold');
  doc.setFontSize(titleSize);
  addText(
    doc,
    'RESUMEN DE VENTAS BRUTAS POR TIPO DE COMPROBANTE Y SERVICIO',
    pageWidth / 2,
    25,
    pageWidth - 20,
  );

  setFont(doc, 'normal');
  doc.setFontSize(paragraphSize);

  addText(
    doc,
    `Fecha impresión: ${tzNormalizeDate({ format: DATE_FORMAT })}`,
    pageWidth - margin - 2,
    40,
    150,
    'right',
  );
  addText(
    doc,
    `Hora de impresión: ${tzNormalizeDate({ format: TIME_FORMAT })}`,
    pageWidth - margin - 2,
    46,
    150,
    'right',
  );

  const bodyRows = rows.map((r) => [
    r.documentCode,
    r.description,
    fmtMoney(r.exemptAmount),
    fmtMoney(r.taxableAmount),
    fmtMoney(r.taxAmount),
    fmtMoney(r.netAmount),
    fmtMoney(r.totalAmount),
  ]);

  if (electronicTotal) {
    bodyRows.push({
      isTotal: true,
      data: [
        electronicTotal.documentCode,
        electronicTotal.description,
        fmtMoney(electronicTotal.exemptAmount),
        fmtMoney(electronicTotal.taxableAmount),
        fmtMoney(electronicTotal.taxAmount),
        fmtMoney(electronicTotal.netAmount),
        fmtMoney(electronicTotal.totalAmount),
      ],
    });
  }

  autoTable(doc, {
    startY: 60,
    theme: 'grid',

    tableWidth: 'fill',
    headStyles: { fillColor: [107, 44, 143], textColor: '#fff' },

    columnStyles: {
      0: { halign: 'center' },
      1: { halign: 'left' },
      2: { halign: 'right' },
      3: { halign: 'right' },
      4: { halign: 'right' },
      5: { halign: 'right' },
      6: { halign: 'right' },
    },

    head: [
      [
        {
          content: 'TIPO DE COMPROBANTE',
          colSpan: 7,
          styles: { halign: 'center', fontStyle: 'bold' },
        },
      ],
      [
        { content: 'N°', styles: { fontStyle: 'bold' } },
        { content: 'DESCRIPCIÓN', styles: { fontStyle: 'bold' } },
        { content: 'EXONERADO' },
        { content: 'BASE IMPONIBLE DE LA OPERACION GRAVADA' },
        { content: 'IGV' },
        { content: 'IMPORTE TOTAL DE LA OPERACION GRAVADA' },
        { content: 'TOTAL VENTA' },
      ],
    ],

    body: bodyRows.map((r) => (r.isTotal ? r.data : r)),

    styles: {
      font: 'Tahoma',
      fontSize: 8,
      cellPadding: 2,
    },

    didParseCell: (dataCell) => {
      const { cell, row, section } = dataCell;
      const cellStyles = { ...cell.styles };

      if (section === 'body' && !row.raw.isTotal) {
        if (row.index % 2 === 1) {
          cellStyles.fillColor = [250, 246, 255];
        }
      }

      if (row.raw.isTotal) {
        cellStyles.fillColor = [255, 15, 123];
        cellStyles.textColor = '#fff';
        cellStyles.fontStyle = 'bold';
      }

      cell.styles = cellStyles;
    },
  });

  window.open(doc.output('bloburl'), '_blank');
};

export default printBillingSummary;
